import {
  SCAN_PRODUCT_SUCCESS,
  ADD_TO_PO,
  UPDATE_EXTERNAL_PO_LINE,
  REMOVE_FROM_PO,
  ADJUST_TAX_PERCENT,
  UPDATE_PO_QUANTITY,
  OVERRIDE_UNIT_COST,
  OVERRIDE_UNIT_TAX,
  PURCHASE_ORDER_FIND_SUCCESS,
  PURCHASE_ORDER_FIND_REQUESTED,
  RESET_PO_LINES,
} from '../types';

const INITIAL_STATE = {
  lineItems: [],
  lineDetails: {}
};

const purchaseOrderLines = (state = INITIAL_STATE, action) => {
  const newState = { ...state };

  switch(action.type) {
    case SCAN_PRODUCT_SUCCESS:
    case ADD_TO_PO:
      let newKey = action.payload.productId + '/' + action?.payload?.variantId;
      if(!(newKey in newState.lineDetails)) {
        newState.lineItems.push(action.payload);
        newState.lineDetails[newKey] = {
          quantity: action.payload.setQuantity || action.payload.minimumOrder
        }
      }
      
    return newState;

    case UPDATE_EXTERNAL_PO_LINE:
      let updateIndex = newState.lineItems.findIndex(line => line.productId === action.payload.productId);
      newState.lineItems[updateIndex] = action.payload;
    return newState;

    case UPDATE_PO_QUANTITY:
      newState.lineDetails[action.key]['quantity'] = action.data;
    return newState;

    case OVERRIDE_UNIT_COST:
      newState.lineDetails[action.key]['adjustedUnitCost'] = action.data;
    return newState;

    case OVERRIDE_UNIT_TAX:
      newState.lineDetails[action.key]['adjustedTax'] = action.data;
    return newState;

    case REMOVE_FROM_PO:
      delete newState.lineDetails[action.key];
      newState.lineItems = newState.lineItems.filter(item => action.key !== (item.productId + '/' + item.variantId))
    return newState;

    return newState;

    case ADJUST_TAX_PERCENT:

    return newState;

    case RESET_PO_LINES:
    case PURCHASE_ORDER_FIND_REQUESTED:
      newState.lineItems = [];
      newState.lineDetails = {};
    return newState;

    case PURCHASE_ORDER_FIND_SUCCESS:
      action.payload.purchase_order_lines['purchase_order_lines'].forEach(purchaseOrderLine => {
        let newKey = purchaseOrderLine.product_id + '/' + purchaseOrderLine.variant_id;
        newState.lineItems.push({
          imageUrl: purchaseOrderLine.source_image_url,
          fullImageUrl: purchaseOrderLine.source_full_image_url,
          options: purchaseOrderLine.source_options,
          productId: purchaseOrderLine.product_id,
          productName: purchaseOrderLine.product_name || purchaseOrderLine.source_name,
          sku: purchaseOrderLine.source_sku,
          supplier_sku: purchaseOrderLine.supplier_sku,
          supplier_price: purchaseOrderLine.supplier_price,
          upc: purchaseOrderLine.source_upc,
          variantId: purchaseOrderLine.variant_id,
          is_external: purchaseOrderLine.is_external,
        });

        let newDetail = {};
        newDetail.existingId = purchaseOrderLine.id;
        newDetail.quantity = purchaseOrderLine.count;
        newDetail.adjustedUnitCost = purchaseOrderLine.supplier_price;
        newDetail.adjustedTax = purchaseOrderLine.adjusted_tax;

        newState.lineDetails[newKey] = newDetail;

      });
    return newState;


    default:
      return state;
  }
}

export default purchaseOrderLines;


